import React from 'react';

/**
 * Composant de chargement optimisé pour les lazy-loaded routes
 * Affiche un spinner minimaliste avec une animation fluide
 */
const LoadingFallback = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      width: '100%'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px'
      }}>
        {/* Spinner animé */}
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        
        {/* Texte de chargement */}
        <p style={{
          color: '#6b7280',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Chargement...
        </p>
      </div>
      
      {/* CSS inline pour l'animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingFallback;
